/// <reference path="../models/meevo.model.custom.ts" />
/// <reference path="../models/meevo.dtos.d.ts" />
/// <reference path="./dataMaintenanceSectionBase.ts" />

module Meevo.Components.BaseClasses {

    /**
     * Base Class of Custom Section
     */
    export class CustomSection extends DataMaintenanceSectionBase<Model.DataMaintenance> {
        constructor(params: Meevo.Model.ISectionParamsBaseDataService) {
            const {
                sectionId, displayNameContentKey, template,
                isPrimarySection, handlesOwnCrud, baseEndpoint,
                sectionEndpoint, loggingService, dataService,
                appSettings, identityService, sectionSecurityKey, noun
            } = params;

            super(
                sectionId, displayNameContentKey, template,
                isPrimarySection, handlesOwnCrud, baseEndpoint,
                sectionEndpoint, loggingService, dataService,
                identityService, noun, appSettings, sectionSecurityKey);
        }
    }
}
